import * as React from "react";
import { useState } from "react";
import { Typography, TextField, Button, Box, IconButton, InputAdornment } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import accountApi from "../app/AccountApi";
import AvatarBox from "./AvatarBox";
import session from "../app/Session";
import routes from "./routes";
import { UnauthorizedError } from "../app/errors";
import { useKeycloak } from "./hooks";

const Login = () => {
  const { t } = useTranslation();
  const [error, setError] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const { login_url, code_verifier, authParams, authenticate, hasKeycloakParams } = useKeycloak("https://kidp.keosapp.com");

  const authUser = React.useCallback(async () => {
    if (hasKeycloakParams()) {
      const authResponse = await authenticate();

      try {
        console.log(`[Login] User auth for user ${authResponse.data.preferred_username} successful, token is ${authResponse.data.token}`);
        await session.store(authResponse.data.preferred_username, authResponse.data.token);
        // window.location.href = routes.app;
        window.location = "/";
      } catch (e) {
        console.log(`[Login] User auth for user ${authResponse.data.preferred_username} failed`, e);
        if (e instanceof UnauthorizedError) {
          setError(t("Login failed: Invalid username or password"));
        } else {
          setError(e.message);
        }
      }
    }
  }, []);

  React.useEffect(() => {
    authUser();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const user = { username, password };
    try {
      const token = await accountApi.login(user);
      console.log(`[Login] User auth for user ${user.username} successful, token is ${token}`);
      await session.store(user.username, token);
      window.location.href = routes.app;
    } catch (e) {
      console.log(`[Login] User auth for user ${user.username} failed`, e);
      if (e instanceof UnauthorizedError) {
        setError(t("Login failed: Invalid username or password"));
      } else {
        setError(e.message);
      }
    }
  };
  if (!config.enable_login) {
    return (
      <AvatarBox>
        <Typography sx={{ typography: "h6" }}>{t("login_disabled")}</Typography>
      </AvatarBox>
    );
  }
  return (
    <AvatarBox>
      <Typography sx={{ typography: "h6" }}>{t("login_title")}</Typography>

      <Box
        component="form"
        onSubmit={async () => {
          const authURL = await login_url();
          console.log(authURL);
          window.location = authURL;
        }}
        noValidate
        sx={{ mt: 1 }}
      >
        {/* <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}> */}
        <Button type="submit" fullWidth variant="contained" sx={{ mt: 2, mb: 2 }}>
          {t("login_form_button_submit")}
        </Button>
        {error && (
          <Box
            sx={{
              mb: 1,
              display: "flex",
              flexGrow: 1,
              justifyContent: "center",
            }}
          >
            <WarningAmberIcon color="error" sx={{ mr: 1 }} />
            <Typography sx={{ color: "error.main" }}>{error}</Typography>
          </Box>
        )}
      </Box>
    </AvatarBox>
  );
};

export default Login;
